import ENDPOINT from 'constants/endpoints';
import { axiosInstance } from 'utils/axiosInstance';

export const generateRefferalCode = async () => (
  axiosInstance.post(`${ENDPOINT.REFERRAL_CODE}`)
);

export const updateRefferalCode = async (data: { referral_code: string }) => (
  axiosInstance.patch(`${ENDPOINT.REFERRAL_CODE}`, data)
);